import React from 'react';
import { fetchWrapper } from '../../APIManager';
const ModeratorStateContext = /*#__PURE__*/React.createContext();
const ModeratorDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  topic_id_with_new_category: null,
  move_reply_original_topic_id: null,
  move_reply_destination_topic_id: null,
  pinned_topic_id: null,
  unpinned_topic_id: null
};

/** REDUCER **/
function ModeratorReducer(state, action) {
  switch (action.type) {
    case 'GET_INITIAL':
      return initialState;
    case 'SET_TOPIC_ID_WITH_NEW_CATEGORY_HOME':
      return {
        ...state,
        topic_id_with_new_category: action.payload
      };
    case 'SET_MOVE_REPLY_ORIGINAL_TOPIC_ID':
      return {
        ...state,
        move_reply_original_topic_id: action.payload
      };
    case 'SET_MOVE_REPLY_DESTINATION_TOPIC_ID':
      return {
        ...state,
        move_reply_destination_topic_id: action.payload
      };
    case 'SET_PINNED_TOPIC_ID':
      return {
        ...state,
        pinned_topic_id: action.payload
      };
    case 'SET_UNPINNED_TOPIC_ID':
      return {
        ...state,
        unpinned_topic_id: action.payload
      };
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function ModeratorProvider({
  value,
  children
}) {
  const [state, dispatch] = React.useReducer(ModeratorReducer, initialState);
  return /*#__PURE__*/React.createElement(ModeratorStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(ModeratorDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useModeratorState() {
  const context = React.useContext(ModeratorStateContext);
  if (context === undefined) {
    throw new Error('useModeratorState must be used within a ModeratorProvider');
  }
  return context;
}
function useModeratorDispatch() {
  const context = React.useContext(ModeratorDispatchContext);
  if (context === undefined) {
    throw new Error('useModeratorDispatch must be used within a ModeratorProvider');
  }
  return context;
}

/** API **/
const moderatorAPI = {
  movePostToAnotherTopic: async function (url, currentTopicID, apiKey, data) {
    try {
      /**
       * Regarding sorting posts after move:
       * What Discourse does: in the order when each reply was migrated
       * What the app does: reverse chronological (created_at)
       */
      const slug = `/t/${currentTopicID}/move-posts`;
      const response = await fetchWrapper(url, slug, apiKey, 'POST', data);
      if (!response || !(response !== null && response !== void 0 && response.success)) {
        throw new Error('Request to move post to another topic failed');
      }
      return response;
    } catch (err) {
      return {};
    }
  },
  updateTopicStatus: async (url, topicID, apiKey, data) => {
    try {
      const slug = `/t/${topicID}/status.json`;
      const response = await fetchWrapper(url, slug, apiKey, 'PUT', data);
      if (!response || response && response.success !== 'OK') {
        throw new Error('Failed to pin the topic.');
      }
      return response;
    } catch (err) {
      return {};
    }
  }
};
export { ModeratorProvider, useModeratorState, useModeratorDispatch, moderatorAPI };
//# sourceMappingURL=index.js.map